module.exports = __webpack_public_path__ + "img/40_00_083_006.6aa8ee98.jpg";